module.exports = __webpack_public_path__ + "assets/basecamp.e95fb561.svg";